<template>
    <div id="banner">
        <div v-if="loading" class="spinner-container">
            <Spinner/>
        </div>
        <div v-else class="container">
            <div v-if="errorFetching" class="banner-box">
                <img alt=""/>
            </div>
            <div v-else class="banner-box">
                <img :src="image_url" alt="" @click="loadBannerUrl"/>
            </div>
        </div>
    </div>
</template>

<script>
import resources from "../../resources";
import Spinner from "../Spinner";
import { UserVideoConfig } from "../../modules/video/UserVideoConfig";

export default {
    components: {
        Spinner,
    },
    data(){
        return {
            mobile_image_url: null,
            desktop_image_url: null,
            link: null,
            loading: true,
            errorFetching: false,
            image_url: null,
        }
    },
    methods: {
        loadBannerUrl() {
            // Fetch for the banner url.
            window.location.replace(this.link);
        },
        setImageUrl() {
            // Is Mobile or Desktop
            const isMobile = UserVideoConfig.isMobile;

            if (isMobile || !this.desktop_image_url) {
                this.image_url = this.mobile_image_url;
            } else {
                this.image_url = this.desktop_image_url;
            }

            if (!this.image_url) {
                this.image_url = this.mobile_image_url || this.desktop_image_url;
            }
        }
    },
    mounted() {
        // Fetch for the banner data.
        resources.banners.getHomeBanner()
        .then((response) => {
            const data = response.body.data[0];

            this.mobile_image_url = data.mobile_image_url;
            this.desktop_image_url = data.desktop_image_url;
            this.link = data.link;

            this.setImageUrl();

            this.errorFetching = false;
        })
        .catch(() => {
            this.errorFetching = true;
        })
        .finally(() => {
            this.loading = false;
        });
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

#banner {
    background-color: var(--pallete_clear_color);
    padding-block: 2em;
    padding-inline: 3em;
    margin-block: 1em;

    @media (max-width: $MOBILE_DISPLAY) {
        padding: 30px 7px;
    }

    .container {
        display: flex;
        justify-content: center;
        align-items: center;

        .banner-box {
            display: flex;
            width: 100%;
            justify-content: center;
            position: relative;
            max-height: 100vh;

            @media (max-width: $MOBILE_DISPLAY) {
                height: auto;
                width: 100%;
            }

            img {
                cursor: pointer;
                max-width: 100%;
                object-fit: contain;
                max-height: fit-content;
                height: auto;

                @media (max-width: $MOBILE_DISPLAY) {
                    width: 100%;
                }
            }
        }
    }
}
</style>
